import { AxiosResponse } from "axios";
import HttpService from "./interface/HttpService";
import { Appliance } from "../model/appliance";

class ApplianceService {
  private instance: HttpService;
  private controllerName: string = 'appliance';

  constructor() {
    this.instance = new HttpService(this.controllerName);
  }

  public getAll(search: string | undefined): Promise<AxiosResponse<Appliance[]>> {
    return this.instance.get('all', { params: { search } });
  }

  public async addAppliance(obj: any): Promise<AxiosResponse<Appliance>> {
    const url = undefined;

    const formData = new FormData();
    formData.append('name', obj.name);
    formData.append('power', obj.power);
    formData.append('icon', obj.icon);
    formData.append('applianceCategoryId', obj.applianceCategoryId);

    return this.instance.post(url, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
  }

  public async editAppliance(obj: any): Promise<AxiosResponse<Appliance>> {
    const url = undefined;

    const formData = new FormData();
    formData.append('id', obj.id);
    formData.append('name', obj.name);
    formData.append('power', obj.power);
    formData.append('applianceCategoryId', obj.applianceCategoryId);

    if (obj.iconEdited) {
      let blob = await fetch(obj.iconUrl.url).then(r => r.blob());

      let file = new File([blob], obj.iconUrl.name, { type: blob.type });

      formData.append('icon', file, file.name);
    }

    return this.instance.put(url, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
  }

  public deleteAppliance(obj: any): Promise<AxiosResponse> {

    return this.instance.delete(`${obj.id}`);
  }
}

export default ApplianceService;